export default __webpack_public_path__ + "static/media/info.75e74822.svg";